import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import AddressInputComponent from './AddressInputComponent';

interface Props {
  question: FlowsQuestion;
}

const AddressInputComponentPicker: React.FC<Props> = ({ ...props }) => {
  return <AddressInputComponent {...props} />;
};

export default AddressInputComponentPicker;
